export enum MapboxPlaceType {
  country = 'distrcict',
  region = 'city',
  district = 'distrcict',
  postcode = 'distrcict',
  place = 'organization',
  locality = 'distrcict',
  neighborhood = 'distrcict',
  address = 'distrcict',
  poi = 'organization',
  airport = 'airport',
  hotel = 'hotel',
  motel = 'hotel',
  tourism = 'hotel',
  lodging = 'lodging',
  art = 'organization',
  business = 'organization',
  service = 'organization',
  building = 'organization',
  high = 'organization',
  college = 'organization',
  university = 'organization',
  beauty = 'organization',
  hair = 'organization',
  salon = 'organization',
  barber = 'organization',
  hairdresser = 'organization',
  coffee = 'organization',
  cafe = 'organization',
}
